// extracted by mini-css-extract-plugin
module.exports = {"iconLoading":"style_iconLoading__KyfSz"};